/* eslint-disable @typescript-eslint/default-param-last */
export const initialState = {
  paint: {
    F0: 0.13,
    roughness: 0.03,
    specularScale: 0.001,
  },
  light: {
    diffuseScale: 0.3,
    eyeDirection: [0, 0, 1],
    lightDirection: [0.514, 0.514, 0.686],
    minimalNormalScale: 5.0,
  },
  ui: {
    showBrush: false,
  },
  global: {
    alpha: 0.5,
    useGlobalAlpha: false,
  },
  currentLayer: {
    showPencil: true,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default reducer;
